import EmbedEditor from './EmbedEditor';

export default EmbedEditor;
